import { AutoComplete, Select } from 'antd';
import React, { ReactElement, useState, useEffect } from 'react';
import { convertToValidStr } from '../../../../utils/utility';
import { NON_NAME_REGEX, MAX_CHARACTERS_LIMIT } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

export const FormAutoComplete = (props: any): (ReactElement | null) => {
  const [extraRules, setExtraRules] = useState<any[]>([]);
  const formConfig = useGetFormConfig(props);
  const {
    disabled, options = [], placeholder, onChange: onChangeFromOrigin, onSelect,
    onSearch: onSearchOrigin, form, isName, key, allowClear,
  } = formConfig;
  const { Option } = Select;

  useEffect((): void => { // on load to set validation
    if (form.getFieldsValue([key])) {
      setExtraRules([{
        max: MAX_CHARACTERS_LIMIT,
      }]);
    }
  }, []);

  const onChange = (ele: any): void => {
    setExtraRules([]);
    onChangeFromOrigin(ele);
    if (form?.getFieldsValue(['doctorName'])) {
      setExtraRules([{
        max: MAX_CHARACTERS_LIMIT,
      }]);
    }
  };

  const onSelectOption = (option: any, value: any): any => {
    if (form?.getFieldsValue(['doctorName'])) {
      setExtraRules([{
        max: MAX_CHARACTERS_LIMIT,
      }]);
    }
    onSelect(value, option);
  };

  const onSearch = (value: string): void => {
    let validStr = convertToValidStr(value);
    if (isName) {
      validStr = validStr.replace(NON_NAME_REGEX, '');
    }
    if (form) {
      form.setFieldsValue({ [key]: validStr });
    }
    setExtraRules([{
      max: MAX_CHARACTERS_LIMIT,
    }]);
    onSearchOrigin(validStr);
  };

  return <FormItem formConfig={formConfig} extraRules={extraRules}>
    <AutoComplete
      disabled={disabled}
      placeholder={placeholder}
      allowClear={allowClear}
      optionFilterProp="children"
      onSearch={onSearch}
      onChange={onChange}
      onSelect={(value: any, option: any): any => onSelectOption(option, value)}
      data-testid={key}
      filterOption={(inputValue: string, option: any): boolean =>
        (option?.children || '').toUpperCase().indexOf(('' + inputValue).toUpperCase()) !== -1
      }
    >
      {
        options?.map((option: any): ReactElement => {
          let name = option;
          let value = option;
          if (option.value && option.name) {
            name = option.name;
            value = option.value || option.name;
          }
          if (typeof value !== 'string') {
            value = `${value}`;
          }
          return <Option key={value} value={name} data-testid={`${key}-${value}`}>{name}</Option>;
        })
      }
    </AutoComplete>
  </FormItem>;
};

export default FormAutoComplete;
